import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Agency, SharedJob, SharedJobsState } from "../types/sharedJobsTypes";

const initialState: SharedJobsState = {
  sharedJobs: [],
  count: 0,
  loading: false,
  error: null,
  agencies: [],
  agenciesLoading: false,
};

const sharedJobsSlice = createSlice({
  name: "sharedJobs",
  initialState,
  reducers: {
    setSharedJobs: (
      state: SharedJobsState,
      action: PayloadAction<SharedJob[]>
    ) => {
      state.sharedJobs = action.payload;
    },
    setSharedJobsCount: (
      state: SharedJobsState,
      action: PayloadAction<number>
    ) => {
      state.count = action.payload;
    },
    setSharedJobsLoading: (
      state: SharedJobsState,
      action: PayloadAction<boolean>
    ) => {
      state.loading = action.payload;
    },
    setSharedJobsError: (
      state: SharedJobsState,
      action: PayloadAction<string | null>
    ) => {
      state.error = action.payload;
    },
    setAgencies: (
      state: SharedJobsState,
      action: PayloadAction<Agency[]>
    ) => {
      state.agencies = action.payload;
    },
    setAgenciesLoading: (
      state: SharedJobsState,
      action: PayloadAction<boolean>
    ) => {
      state.agenciesLoading = action.payload;
    },
  },
});

export const {
  setSharedJobs,
  setSharedJobsCount,
  setSharedJobsLoading,
  setSharedJobsError,
  setAgencies,
  setAgenciesLoading,
} = sharedJobsSlice.actions;

export default sharedJobsSlice.reducer;
